




import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";
import app from "@/app";
import { tViewDialog } from "oweb";

@Component
export default class WDialog extends BaseComponent {
	@Prop({ type: Object, required: true })
	dialog!: tViewDialog;

	@Prop({ type: Number, default: 5000 })
	duration!: number;

	timeout: any = null;

	selfRemove() {
		let list = app.store.dialogs;
		list.splice(list.indexOf(this.dialog), 1);
	}

	mounted() {
		let x = this;
		this.timeout = setTimeout(() => {
			x.selfRemove();
		}, this.duration);
	}

	destroy() {
		clearTimeout(this.timeout);
	}
}
